/**
 * Typography Configuration
 *
 * Design Rationale:
 * - Inter is chosen as the primary font for its exceptional readability at all sizes,
 *   neutral character, and excellent support for data-dense interfaces
 * - Slightly relaxed line heights (1.5-1.7) reduce eye strain during long sessions
 * - Restrained font weights (400-600) create hierarchy without visual noise
 * - Letter spacing is optimized per size for optical balance
 */

const fontFamily = "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', sans-serif";

const typography = {
    fontFamily,
    fontSize: 14,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 600,

    // Headlines - Clear hierarchy, not overpowering
    // h1: {
    //     fontFamily,
    //     fontSize: '2.25rem',
    //     fontWeight: 600,
    //     lineHeight: 1.3,
    //     letterSpacing: '-0.02em',
    // },
    // h2: {
    //     fontFamily,
    //     fontSize: '1.75rem',
    //     fontWeight: 600,
    //     lineHeight: 1.35,
    //     letterSpacing: '-0.015em',
    // },
    // h3: {
    //     fontFamily,
    //     fontSize: '1.375rem',
    //     fontWeight: 600,
    //     lineHeight: 1.4,
    //     letterSpacing: '-0.01em',
    // },
    // h4: {
    //     fontFamily,
    //     fontSize: '1.125rem',
    //     fontWeight: 600,
    //     lineHeight: 1.45,
    //     letterSpacing: '-0.005em',
    // },
    // h5: {
    //     fontFamily,
    //     fontSize: '1rem',
    //     fontWeight: 600,
    //     lineHeight: 1.5,
    //     letterSpacing: '0',
    // },
    // h6: {
    //     fontFamily,
    //     fontSize: '0.875rem',
    //     fontWeight: 600,
    //     lineHeight: 1.5,
    //     letterSpacing: '0.005em',
    // },
    //
    // // Subtitles - For secondary headings and emphasis
    // subtitle1: {
    //     fontFamily,
    //     fontSize: '1rem',
    //     fontWeight: 500,
    //     lineHeight: 1.5,
    //     letterSpacing: '0.005em',
    // },
    // subtitle2: {
    //     fontFamily,
    //     fontSize: '0.875rem',
    //     fontWeight: 500,
    //     lineHeight: 1.5,
    //     letterSpacing: '0.01em',
    // },
    //
    // // Body text - Optimized for extended reading
    // body1: {
    //     fontFamily,
    //     fontSize: '0.9375rem', // 15px - slightly larger for comfort
    //     fontWeight: 400,
    //     lineHeight: 1.6,
    //     letterSpacing: '0.01em',
    // },
    // body2: {
    //     fontFamily,
    //     fontSize: '0.8125rem', // 13px
    //     fontWeight: 400,
    //     lineHeight: 1.55,
    //     letterSpacing: '0.01em',
    // },
    //
    // // UI text
    // button: {
    //     fontFamily,
    //     fontSize: '0.875rem',
    //     fontWeight: 500,
    //     lineHeight: 1.5,
    //     letterSpacing: '0.02em',
    //     textTransform: 'none',
    // },
    // caption: {
    //     fontFamily,
    //     fontSize: '0.75rem',
    //     fontWeight: 400,
    //     lineHeight: 1.5,
    //     letterSpacing: '0.02em',
    // },
    // overline: {
    //     fontFamily,
    //     fontSize: '0.6875rem',
    //     fontWeight: 600,
    //     lineHeight: 1.5,
    //     letterSpacing: '0.08em',
    //     textTransform: 'uppercase',
    // },
    //
    // // Custom list styles
    // ul: {
    //     paddingLeft: '1.5rem',
    //     margin: '0.75rem 0',
    //     fontSize: '0.9375rem',
    //     fontWeight: 400,
    //     lineHeight: 1.6,
    //     fontFamily,
    // },
    // ol: {
    //     paddingLeft: '1.5rem',
    //     margin: '0.75rem 0',
    //     fontSize: '0.9375rem',
    //     fontWeight: 400,
    //     lineHeight: 1.6,
    //     fontFamily,
    // },
    // li: {
    //     marginBottom: '0.375rem',
    //     fontSize: '0.9375rem',
    //     fontWeight: 400,
    //     lineHeight: 1.6,
    //     fontFamily,
    // },
};

export default typography;
